import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "pb-5" }
const _hoisted_3 = { class: "d-flex align-items-center landingSubtitle" }
const _hoisted_4 = { class: "pb-5" }
const _hoisted_5 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_6 = { class: "form-floating mb-5" }
const _hoisted_7 = { class: "form-label mb-3 required" }
const _hoisted_8 = { class: "input-group mb-5" }
const _hoisted_9 = { class: "form-floating flex-grow-1" }
const _hoisted_10 = { class: "form-label mb-3 required" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  style: {"border":"none"},
  class: "form-control-solid input-group-text"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone fs-2x" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.i18n("pasoinicial")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.i18n("FamiliaGroupLabel")), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives(_createElementVNode("input", {
        name: "dni",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dni) = $event)),
        type: "text",
        class: "form-control form-control-lg form-control-solid",
        placeholder: " "
      }, null, 512), [
        [_vModelText, _ctx.dni]
      ]),
      _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.i18n("FamiliaDNILabel")), 1),
      _createVNode(_component_ErrorMessage, {
        name: "dni",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _withDirectives(_createElementVNode("input", {
          id: "telefono",
          name: "telefono",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.telefono) = $event)),
          type: "tel",
          class: "form-control form-control-lg form-control-solid",
          placeholder: " "
        }, null, 512), [
          [_vModelText, _ctx.telefono]
        ]),
        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.i18n("FamiliaTelefonoLabel")), 1)
      ]),
      _hoisted_11,
      _createVNode(_component_ErrorMessage, {
        name: "telefono",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ])
  ]))
}